import { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AdminAppBar from "../../../adminComponents/AdminAppBar";
import BackArrows from "../../../Form/BackArrow/BackArrows";
import StepProgress from "../StepProgress";
import PropertyInfoForm from "./LayoutPropertyInfoForm";
import LayoutUnitTable from "./LayoutUnitTable";
import LayoutUnitForm from "./LayoutUnitForm";
import { getIcons, userUid } from "../../../Constant/Constant";
import { TbFileSymlink } from "react-icons/tb";
import { MdAddCircleOutline } from "react-icons/md";
import PropertiesService from "../../../Services/PropertiesService";
import { FiSearch } from "react-icons/fi";
import { LiaFilterSolid } from "react-icons/lia";
import {
  showErrorToast,
  showInfoToast,
  showSuccessToast,
} from "../../../Constant/Notification";
import { toast, ToastContainer } from "react-toastify";
import { plotStatusIds, roadFacingSides } from "../../../../Enum";
import StatusDropdown from "../StatusDropdown";
import VillaTable from "../VillaPropertySection/VillaUnitTable";
import BulkUploadModel from "../BulkUploadModel";
import * as XLSX from "xlsx";
import { userRole } from "../../../../utils/storage";

const LayoutPropertyManage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    selectedPropertyDetails,
    propertySaleType,
    propertyId,
    propertyTypeId,
    propertyName,
    propertyInfoStatus = false,
  } = location.state || {};

  console.log("location state Details:", location.state);

  const editMode = !!propertyId;

  const icons = getIcons();
  const [searchTerm, setSearchTerm] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [editingUnit, setEditingUnit] = useState(null);
  const [isNewUnit, setIsNewUnit] = useState(false);
  const [totalUnitRow, setTotalUnitRow] = useState(0);
  const [previousTotalUnitRow, setPreviousTotalUnitRow] = useState(0);
  const [filteredUnits, setFilteredUnits] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [validationErrors, setValidationErrors] = useState([]);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const [propertyInfo, setPropertyInfo] = useState({
    docId: "",
    name: "",
    locationId: "",
    propertyId: "",
    geoLocation: "",
    propertyTypeId: selectedPropertyDetails?.id || "",
    propertySaleTypeId: propertySaleType || "",
    propertyType: selectedPropertyDetails?.label || "",
    underOfGovernance: "",
    salesTeamIds: [],

    basicAmenitiesIds: [],
    futureAmenitiesIds: [],
    nearByAmenitiesIds: [],
    possessionDate: "",
    propertyImages: [],
    propertyVideos: [],
    propertyDocuments: [],
    propertyFlyers: [],
    propertyBlueprints: [],
    propertyThumbnail: "",
    overAllSqft: 0,
    dtcpNo: "",
    guidelineValue: 0,
    documentType: "",
    landmark: "",
    roiPercentage: "",
    roiYear: "",
    reraId: "",
    surveyFee: 0,
    surveyNo: "",
    documentCharge: 0,
    purchaseDaysCount: 0,
    propertyPurchasedDate: "",
    sro: "",
    taluk: "",
    address: "",
    locationLink: "",
    totalProjectWorth: 0,
    propertySellerName: "",
    propertySellerPhoneNumber: "",
    createdById: userUid,
    modifiedById: "",

    overAllSaleableSqft: 0,
    totalAvailableUnits: 0,
    overAllAvailableSqft: 0,
    availableMinSqft: 0,
    availableMaxSqft: 0,
    availableMinBudget: 0,
    availableMaxBudget: 0,
    bookedUnitcount: 0,
    overAllBookedSqft: 0,
    agreementUnitcount: 0,
    overAllAgreementSqft: 0,
    registeredUnitcount: 0,
    overAllRegisteredSqft: 0,

    //{Villa}
    constructionType: "",
  });

  const [units, setUnits] = useState([]);
  const [modifiedUnitIds, setModifiedUnitIds] = useState(new Set());

  const filterUnits = useCallback(() => {
    let filtered = units.filter((unit) => unit !== null && unit !== undefined);

    if (searchTerm.trim()) {
      filtered = filtered.filter((unit) =>
        unit.unitNo?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (selectedStatus !== "all") {
      filtered = filtered.filter(
        (unit) =>
          unit.unitStatus?.name.toLowerCase() === selectedStatus.toLowerCase()
      );
    }

    if (editMode) {
      if (!(editMode && previousTotalUnitRow === 0)) {
        setTotalUnitRow(filtered.length);
      }
    }

    // setTotalUnitRow(filtered.length);
    setFilteredUnits(filtered);
  }, [units, searchTerm, selectedStatus]);

  // useEffect(() => {
  //   filterUnits();
  // }, [filterUnits]);

  useEffect(() => {
    filterUnits();
  }, [units, selectedStatus]);

  const fetchData = async () => {
    if (editMode && propertyId && propertyTypeId) {
      try {
        const propertyResponse = await PropertiesService.getPropertyById(
          propertyId,
          propertyTypeId
        );
        const apiData = propertyResponse.data?.propertyData || {};

        setPropertyInfo({
          ...propertyInfo,
          docId: propertyId,
          name: apiData.name || "",
          locationId: apiData.location?.id || "",
          geoLocation: apiData.geoLocation || "",
          propertyId: apiData.propertyId || "",
          propertyType:
            apiData.propertyType?.name || selectedPropertyDetails?.label || "",
          propertyTypeId:
            apiData.propertyType?.id || selectedPropertyDetails?.id || "",
          propertySaleTypeId:
            apiData.propertySaleType?.id || propertySaleType || "",
          underOfGovernance: apiData.underOfGovernance || "",
          salesTeamIds: Array.isArray(apiData.salesTeam)
            ? apiData.salesTeam.map((team) => team.id)
            : [],
          basicAmenitiesIds: Array.isArray(apiData.basicAmenities)
            ? apiData.basicAmenities.map((amenity) => amenity.id)
            : [],
          futureAmenitiesIds: Array.isArray(apiData.futureAmenities)
            ? apiData.futureAmenities.map((amenity) => amenity.id)
            : [],
          nearByAmenitiesIds: Array.isArray(apiData.nearByAmenities)
            ? apiData.nearByAmenities.map((amenity) => amenity.id)
            : [],
          propertyImages: Array.isArray(apiData.propertyImages)
            ? apiData.propertyImages.map((img) => img.doc)
            : [],
          propertyVideos: Array.isArray(apiData.propertyVideos)
            ? apiData.propertyVideos.map((video) => video.doc)
            : [],
          propertyDocuments: Array.isArray(apiData.propertyDocuments)
            ? apiData.propertyDocuments.map((doc) => doc.doc)
            : [],
          propertyFlyers: Array.isArray(apiData.propertyFlyers)
            ? apiData.propertyFlyers.map((flyer) => flyer.doc)
            : [],
          propertyBlueprints: Array.isArray(apiData.propertyBlueprints)
            ? apiData.propertyBlueprints.map((bp) => bp.doc)
            : [],
          propertyThumbnail: apiData.propertyThumbnail || "",
          overAllSqft: apiData.overAllSqft || 0,
          dtcpNo: apiData.dtcpNo || "",
          guidelineValue: apiData.guidelineValue || 0,
          documentType: apiData.documentType || "",
          landmark: apiData.landmark || "",
          purchaseDaysCount: apiData.purchaseDaysCount || 0,
          roiPercentage: apiData.roiPercentage || "",
          roiYear: apiData.roiYear || "",
          reraId: apiData.reraId || "",
          surveyFee: apiData.surveyFee || 0,

          surveyNo: apiData.surveyNo || "",
          documentCharge: apiData.documentCharge || 0,
          propertyPurchasedDate: apiData.propertyPurchasedDate || "",
          possessionDate: apiData.possessionDate || "",
          constructionType: apiData.constructionType || "",
          sro: apiData.sro || "",
          taluk: apiData.taluk || "",
          address: apiData.address || "",
          locationLink: apiData.locationLink || "",
          totalProjectWorth: apiData.totalProjectWorth || 0,
          propertySellerName: apiData.propertySellerName || "",
          propertySellerPhoneNumber: apiData.propertySellerPhoneNumber || "",

          overAllSaleableSqft: apiData.overAllSaleableSqft || 0,
          totalAvailableUnits: apiData.totalAvailableUnits || 0,
          overAllAvailableSqft: apiData.overAllAvailableSqft || 0,
          availableMinSqft: apiData.availableMinSqft || 0,
          availableMaxSqft: apiData.availableMaxSqft || 0,
          availableMinBudget: apiData.availableMinBudget || 0,
          availableMaxBudget: apiData.availableMaxBudget || 0,
          bookedUnitcount: apiData.bookedUnitcount || 0,
          overAllBookedSqft: apiData.overAllBookedSqft || 0,
          agreementUnitcount: apiData.agreementUnitcount || 0,
          overAllAgreementSqft: apiData.overAllAgreementSqft || 0,
          registeredUnitcount: apiData.registeredUnitcount || 0,
          overAllRegisteredSqft: apiData.overAllRegisteredSqft || 0,
        });

        const unitsResponse =
          await PropertiesService.getUnitsLayoutsByPropertyId(propertyId);
        const unitsData = unitsResponse.data?.units || [];
        setUnits(unitsData);
        setFilteredUnits(unitsData);
        setPreviousTotalUnitRow(unitsData.length);
        setTotalUnitRow(Math.max(unitsData.length, 0));
      } catch (error) {
        console.error("Error fetching data:", error);
        showErrorToast("Failed to load property or unit data");
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [propertyId, editMode]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    filterUnits();
  };

  const handleStatusFilter = (option) => {
    setSelectedStatus(option.id === "all" ? "all" : option.label);
  };

  const handlePropertyInfoChange = (e) => {
    const { name, value } = e.target;
    setPropertyInfo((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === "geoLocation") {
        const coords = value.split(",").map((c) => c.trim());
        if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
          updated.locationLink = `https://www.google.com/maps?q=${coords[0]},${coords[1]}`;
        } else {
          updated.locationLink = "";
        }
      }
      return updated;
    });
  };

  const handleArrayFieldChange = (field, newArray) => {
    setPropertyInfo((prev) => ({
      ...prev,
      [field]: newArray,
    }));
  };

  const handleNestedPropertyInfoChange = (parentKey, childKey, value) => {
    setPropertyInfo((prev) => ({
      ...prev,
      [parentKey]: {
        ...prev[parentKey],
        [childKey]: value,
      },
    }));
  };

  const handlePrevStep = () => {
    if (totalUnitRow > previousTotalUnitRow) {
      showErrorToast(
        "Cannot go back in previous steps. Please add or remove units to proceed."
      );
    } else {
      if (currentStep > 1) setCurrentStep(currentStep - 1);
    }
  };

  const handleNextViewStep = () => {
    setCurrentStep(2);
  };
  const handlePrevViewStep = () => {
    if (totalUnitRow > previousTotalUnitRow) {
      showErrorToast(
        "Cannot go back in previous steps. Please add or remove units to proceed."
      );
    } else {
      if (currentStep > 1) setCurrentStep(currentStep - 1);
    }
  };

  const handleNextStep = async () => {
    if (!propertyInfo.name.trim()) {
      showErrorToast("Property name is required!");
      return;
    }
    if (propertyInfo?.overAllSqft <= 0) {
      showErrorToast("Over-All Square Feet is required!");
      return;
    }
    // if (propertyInfo?.guidelineValue <= 0) {
    //   showErrorToast("Guideline Value is required!");
    //   return;
    // }

    if (propertyInfo.geoLocation.trim() === "") {
      showErrorToast("Geolocation is required!");
      return;
    }
    if (propertyInfo.locationId.trim() === "") {
      showErrorToast("Location is required!");
      return;
    }
    if (propertyInfo.address.trim() === "") {
      showErrorToast("Address is required!");
      return;
    }

    setIsLoading(true);

    try {
      let savedPropertyId = propertyInfo.id;
      let propertyPayload = {
        name: propertyInfo.name || null,
        locationId: propertyInfo.locationId || null,
        geoLocation: propertyInfo.geoLocation || null,
        propertyTypeId: propertyInfo?.propertyTypeId || null,
        propertySaleTypeId: propertyInfo.propertySaleTypeId || null,
        underOfGovernance: propertyInfo.underOfGovernance || null,
        salesTeamIds: Array.isArray(propertyInfo.salesTeamIds)
          ? propertyInfo.salesTeamIds
          : [propertyInfo.salesTeamIds].filter(Boolean),
        basicAmenitiesIds: Array.isArray(propertyInfo.basicAmenitiesIds)
          ? propertyInfo.basicAmenitiesIds
          : [propertyInfo.basicAmenitiesIds].filter(Boolean),
        futureAmenitiesIds: Array.isArray(propertyInfo.futureAmenitiesIds)
          ? propertyInfo.futureAmenitiesIds
          : [propertyInfo.futureAmenitiesIds].filter(Boolean),
        nearByAmenitiesIds: Array.isArray(propertyInfo.nearByAmenitiesIds)
          ? propertyInfo.nearByAmenitiesIds
          : [propertyInfo.nearByAmenitiesIds].filter(Boolean),
        propertyImages: Array.isArray(propertyInfo.propertyImages)
          ? propertyInfo.propertyImages
          : [propertyInfo.propertyImages].filter(Boolean),
        propertyVideos: Array.isArray(propertyInfo.propertyVideos)
          ? propertyInfo.propertyVideos
          : [propertyInfo.propertyVideos].filter(Boolean),
        propertyDocuments: Array.isArray(propertyInfo.propertyDocuments)
          ? propertyInfo.propertyDocuments
          : [propertyInfo.propertyDocuments].filter(Boolean),
        propertyFlyers: Array.isArray(propertyInfo.propertyFlyers)
          ? propertyInfo.propertyFlyers
          : [propertyInfo.propertyFlyers].filter(Boolean),
        propertyBlueprints: Array.isArray(propertyInfo.propertyBlueprints)
          ? propertyInfo.propertyBlueprints
          : [propertyInfo.propertyBlueprints].filter(Boolean),
        propertyThumbnail: propertyInfo.propertyThumbnail || null,
        overAllSqft: Number(propertyInfo.overAllSqft) || 0,
        dtcpNo: propertyInfo.dtcpNo || null,
        guidelineValue: Number(propertyInfo.guidelineValue) || 0,
        documentType: propertyInfo.documentType || null,
        landmark: propertyInfo.landmark || null,
        roiPercentage: Number(propertyInfo.roiPercentage) || null,
        roiYear: Number(propertyInfo.roiYear) || null,
        reraId: propertyInfo.reraId || null,
        surveyFee: Number(propertyInfo.surveyFee) || 0,
        surveyNo: propertyInfo.surveyNo || null,
        documentCharge: Number(propertyInfo.documentCharge) || 0,
        propertyPurchasedDate: propertyInfo.propertyPurchasedDate || null,
        sro: propertyInfo.sro || null,
        possessionDate: propertyInfo.possessionDate || null,

        taluk: propertyInfo.taluk || null,
        address: propertyInfo.address || null,
        locationLink: propertyInfo.locationLink || null,
        totalProjectWorth: Number(propertyInfo.totalProjectWorth) || 0,
        propertySellerName: propertyInfo.propertySellerName || null,
        propertySellerPhoneNumber:
          propertyInfo.propertySellerPhoneNumber || null,
      };

      if (editMode) {
        propertyPayload = {
          ...propertyPayload,
          docId: propertyInfo.docId,
          modifiedById: userUid || null,
          basicAmenitiesIds: Array.isArray(propertyInfo.basicAmenitiesIds)
            ? propertyInfo.basicAmenitiesIds
            : [propertyInfo.basicAmenitiesIds].filter(Boolean),
          futureAmenitiesIds: Array.isArray(propertyInfo.futureAmenitiesIds)
            ? propertyInfo.futureAmenitiesIds
            : [propertyInfo.futureAmenitiesIds].filter(Boolean),
          nearByAmenitiesIds: Array.isArray(propertyInfo.nearByAmenitiesIds)
            ? propertyInfo.nearByAmenitiesIds
            : [propertyInfo.nearByAmenitiesIds].filter(Boolean),
        };
        await PropertiesService.updateProperty(propertyPayload);

        toast.success("Property updated successfully!", {
          autoClose: 1000,
          position: "top-center",
          onClose: () => {
            setIsLoading(false);
            setCurrentStep(2);
          },
        });
        
      } else {
        propertyPayload = {
          ...propertyPayload,
          createdById: userUid || null,
        };
        // if(propertyPayload){
        //   console.log("Property created with propertyPayload:", propertyPayload);
        //   return
        // }
        const response = await PropertiesService.createProperty(
          propertyPayload
        );
        savedPropertyId = response.data.id;
        console.log("Property created with ID:", savedPropertyId);

        setPropertyInfo((prev) => ({ ...prev, docId: savedPropertyId }));

        toast.success("Property created successfully!", {
          autoClose: 1000, 
          position: "top-center",
          onClose: () => {
            setIsLoading(false);
            setCurrentStep(2); 
          },
        });}

    } catch (error) {
      console.error("Error saving property:", error);
      
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddUnit = (newUnit) => {
    const defaultStatus = plotStatusIds.find(
      (status) => status.label === "Available"
    );

    setEditingUnit({
      ...newUnit,
      unitStatus: defaultStatus
        ? { id: defaultStatus.id, name: defaultStatus.label }
        : { id: "", name: "N/A" },
        statusName : defaultStatus ? defaultStatus.label : "N/A",
    });

    setIsNewUnit(true);
    setIsSliderOpen(true);
  };

  const handleEditUnit = (unit) => {
    console.log("Editing unit:", unit);

    setEditingUnit(unit);
    setIsNewUnit(false);

    setIsSliderOpen(true);
  };

  const handleUnitFormChange = (e) => {
    const { name, value } = e.target;

    setEditingUnit((prev) => {
      if (name === "unitStatus") {
        const selectedStatus = plotStatusIds.find(
          (status) => status.id === value
        );
        return {
          ...prev,
          unitStatus: {
            id: value,
            name: selectedStatus ? selectedStatus.label : "",
          },
        };
      }

      if (name === "roadFacingSide") {
        const selectedSide = roadFacingSides.find((side) => side.id === value);
        return {
          ...prev,
          roadFacingSide: {
            id: value,
            name: selectedSide ? selectedSide.label : "",
          },
        };
      }

      return {
        ...prev,
        [name]:
          name.includes("Dimension") ||
          name === "order" ||
          name === "sqft" ||
          name === "ratePerSqft" ||
          name === "guidelineSqftPrice" ||
          name === "roadWidth" ||
          name === "registrationCharge"
            ? Number(value)
            : value,
      };
    });
  };

  // console.log("Total units:", totalUnitRow);
  // console.log("Editing unit:", editingUnit);
  // console.log("Previous units:", previousTotalUnitRow);

  const handleSaveUnit = async () => {
    if (
      editingUnit.unitNo &&
      units.some(
        (unit) =>
          unit &&
          unit.unitNo === editingUnit.unitNo &&
          unit.id !== editingUnit.id
      )
    ) {
      showErrorToast("Unit number already exists!");
      return;
    }

    // Validate all required fields
    if (!editingUnit.unitNo.trim()) {
      showErrorToast("Unit number is required!");
      return;
    }
    if (!editingUnit.sqft || editingUnit.sqft <= 0) {
      showErrorToast("Square footage must be greater than 0!");
      return;
    }
    if (
      !editingUnit.northDimension ||
      editingUnit.northDimension <= 0 ||
      !editingUnit.southDimension ||
      editingUnit.southDimension <= 0 ||
      !editingUnit.westDimension ||
      editingUnit.westDimension <= 0 ||
      !editingUnit.eastDimension ||
      editingUnit.eastDimension <= 0
    ) {
      showErrorToast("All dimension fields must be greater than 0!");
      return;
    }
    if (!editingUnit.roadFacingSide?.id) {
      showErrorToast("Road facing side is required!");
      return;
    }
    if (!editingUnit.ratePerSqft || editingUnit.ratePerSqft <= 0) {
      showErrorToast("Approx. SQ. FT price must be greater than 0!");
      return;
    }
    if (
      !editingUnit.guidelineSqftPrice ||
      editingUnit.guidelineSqftPrice <= 0
    ) {
      showErrorToast("Guideline SQ. FT price must be greater than 0!");
      return;
    }
    if (
      !editingUnit.registrationCharge ||
      editingUnit.registrationCharge <= 0
    ) {
      showErrorToast("Registration charge cannot be negative!");
      return;
    }
    if (!editingUnit.unitStatus?.id) {
      showErrorToast("Unit status is required!");
      return;
    }

    if (editingUnit.unitNo.length > 5) {
      showErrorToast("Unit number cannot exceed 5 characters!");
      return;
    }
    try {
      const unitToSave = {
        ...editingUnit,
        propertyId: propertyInfo.docId,
        createdBy: userUid,
        modifiedBy: userUid,
      };

      if (isNewUnit) {
        setUnits((prevUnits) => {
          const newUnits = [...prevUnits];
          const orderIndex = editingUnit.order - 1;
          const newUnit = {
            ...unitToSave,
            id: `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
            isNew: true,
          };

          while (orderIndex >= newUnits.length) {
            newUnits.push(null);
          }

          newUnits[orderIndex] = newUnit;

          if (orderIndex >= totalUnitRow) {
            setTotalUnitRow(orderIndex + 1);
          }

          return newUnits;
        });
      } else {
        setUnits((prevUnits) => {
          const updatedUnits = prevUnits.map((unit) =>
            unit && unit.id === editingUnit.id
              ? { ...unitToSave, isModified: true }
              : unit
          );

          setModifiedUnitIds((prev) => new Set([...prev, editingUnit.id]));
          return updatedUnits;
        });
      }
      filterUnits();
      setIsSliderOpen(false);
      setEditingUnit(null);
      //  showSuccessToast(`Unit ${isNewUnit ? "added" : "updated"} successfully!`);
    } catch (error) {
      console.error("Error saving unit:", error);
      showErrorToast(`Failed to ${isNewUnit ? "add" : "update"} unit!`);
    }
  };

  const handleCancelUnitEdit = () => {
    setIsSliderOpen(false);
    setEditingUnit(null);
  };

  const handleSavePropertyLayoutUnit = async () => {
    setIsLoading(true);

    try {
      const validUnits = units.filter(
        (unit) =>
          unit && unit.unitNo?.trim() && unit.sqft > 0 && !unit.isArchived
      );

      if (validUnits.length === 0 && units.some((unit) => unit !== null)) {
        showErrorToast(
          "All units must have a valid unit number and square footage!"
        );
        return;
      }

      const updatedUnits = validUnits.map((unit, index) => ({
        ...unit,
        order: index + 1,
      }));

      const newUnits = updatedUnits.filter(
        (unit) => !unit.id || unit.id.startsWith("temp-")
      );
      const existingUnits = updatedUnits.filter(
        (unit) => unit.id && !unit.id.startsWith("temp-")
      );

      const formatUnit = (unit, isExisting) => ({
        ...(isExisting
          ? { docId: unit.id, modifiedBy: userUid }
          : { createdBy: userUid }),
        unitNo: unit.unitNo || "",
        order: unit.order,
        sqft: Number(unit.sqft) || 0,
        ratePerSqft: Number(unit.ratePerSqft) || 0,
        guidelineSqftPrice: Number(unit.guidelineSqftPrice) || 0,
        northDimension: Number(unit.northDimension) || 0,
        eastDimension: Number(unit.eastDimension) || 0,
        westDimension: Number(unit.westDimension) || 0,
        southDimension: Number(unit.southDimension) || 0,
        roadFacingSideId: unit.roadFacingSide?.id || "",
        roadWidth: Number(unit.roadWidth) || 0,
        registrationCharge: Number(unit.registrationCharge) || 0,
        unitStatusId: unit.unitStatus?.id || "",
        propertyId: propertyInfo.docId,
      });

      if (newUnits.length > 0) {
        const createPayload = {
          docId: propertyInfo.docId,
          units: newUnits.map((unit) => formatUnit(unit, false)),
        };
        await PropertiesService.createLayoutUnit(createPayload);
      }

      if (existingUnits.length > 0) {
        const updatePayload = {
          docId: propertyInfo.docId,
          units: existingUnits.map((unit) => formatUnit(unit, true)),
        };
        await PropertiesService.updateLayoutUnit(updatePayload);
      }

      if (propertyInfo.docId) {
        const response = await PropertiesService.getUnitsLayoutsByPropertyId(
          propertyInfo.docId
        );
        const refreshedUnits = response.data?.units || [];
        setUnits(refreshedUnits);
        setFilteredUnits(refreshedUnits);

        setTotalUnitRow(Math.max(refreshedUnits.length, totalUnitRow));
        setModifiedUnitIds(new Set());
      }

      showSuccessToast(
        `Property and units ${editMode ? "updated" : "created"} successfully!`
      );
      setTimeout(() => {
        navigate(-1);
      }, 1700);
    } catch (err) {
      console.error("Error saving property and units:", err);
      showErrorToast(
        `Failed to ${editMode ? "update" : "create"} property and units!`
      );
    } finally {
      setIsLoading(false);
    }
  };

//   useEffect(()=>{
// setTimeout(()=>{
//   navigate(-1)
// },1000)
//   },[])

  const getIdByLabel = (list, label) => {
    if (!label || !Array.isArray(list)) return "";
    const match = list.find(
      (item) => item.label?.toLowerCase().trim() === label.toLowerCase().trim()
    );
    return match?.id || "";
  };
  
  const handleBulkUploadLayoutUnits = async (input) => {
    setIsLoading(true);
    const file = input instanceof File ? input : input?.target?.files?.[0];
    if (!file || !(file instanceof Blob)) {
      showErrorToast("Invalid file format or no file selected.");
      return;
    }
  
    const reader = new FileReader();
  
    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        let jsonData = XLSX.utils.sheet_to_json(sheet);
  
        if (!jsonData.length) {
          showErrorToast("Uploaded Excel is empty.");
          return;
        }
  
        if (jsonData.length > 200) {
          setValidationErrors(["Only 200 rows are allowed."]);
          setShowValidationModal(true);
          return;
        }
  
        jsonData = jsonData.map((row) => {
          const newRow = {};
          Object.entries(row).forEach(([key, value]) => {
            const trimmedKey = key.trim().replace(/\s+/g, " ");
            newRow[trimmedKey] = value;
          });
          return newRow;
        });
  
        const seenUnits = new Set();
        const errors = [];
  
        const formattedUnits = jsonData.map((row, index) => {
          const rowNum = index + 2;
  
          const unitNo = row["Unit Number"]?.toString().trim() || "";
  
          if (seenUnits.has(unitNo)) {
            errors.push(`Row ${rowNum}: Duplicate Unit Number "${unitNo}"`);
            setSelectedFile(null);
          }
          seenUnits.add(unitNo);
  
          const requiredFields = [
            "Unit Number",
            "Square Feet",
            "Approx. SQ. FT Price",
            "Guideline SQ. FT Price",
            "North Dimension (In Feet)",
            "East Dimension (In Feet)",
            "West Dimension (In Feet)",
            "South Dimension (In Feet)",
            "Road Facing Side",
            "Registration Charge",
            "Status",
          ];
  
          requiredFields.forEach((field) => {
            const val = row[field];
            if (val === undefined || val === null || val.toString().trim() === "") {
              errors.push(`Row ${rowNum}: ${field} is required.`);
            }
          });
  
          return {
            unitNo,
            order: index + 1,
            sqft: Number(row["Square Feet"]) || 0,
            ratePerSqft: Number(row["Approx. SQ. FT Price"]) || 0,
            guidelineSqftPrice: Number(row["Guideline SQ. FT Price"]) || 0,
            northDimension: Number(row["North Dimension (In Feet)"]) || 0,
            eastDimension: Number(row["East Dimension (In Feet)"]) || 0,
            westDimension: Number(row["West Dimension (In Feet)"]) || 0,
            southDimension: Number(row["South Dimension (In Feet)"]) || 0,
            roadFacingSideId: getIdByLabel(roadFacingSides, row["Road Facing Side"]),
            roadWidth: Number(row["Road Width (In Feet)"]) || 0,
            registrationCharge: Number(row["Registration Charge"]) || 0,
            unitStatusId: getIdByLabel(plotStatusIds, row["Status"]),
            createdBy: userUid,
            propertyId: propertyInfo.docId,
          };
        });
  
        if (errors.length > 0) {
          setValidationErrors(errors);
          setShowValidationModal(true);
          setSelectedFile(null);
          return;
        }
  
        const responseLayout = await PropertiesService.createLayoutUnit({
          docId: propertyInfo.docId,
          units: formattedUnits,
        });
  
        if (responseLayout) {
          const response = await PropertiesService.getUnitsLayoutsByPropertyId(
            propertyInfo.docId
          );
          const refreshedUnits = response.data?.units || [];
  
          setUnits(refreshedUnits);
          setFilteredUnits(refreshedUnits);
          setTotalUnitRow(Math.max(refreshedUnits.length, totalUnitRow));
          setModifiedUnitIds(new Set());
  
         showSuccessToast("Units uploaded successfully!");
  
          setTimeout(() => {
            
            navigate(-1);
           
          }, 2000);
        }
      } catch (err) {
        console.error("Bulk upload error:", err);
        showErrorToast("Failed to upload layout units.");
      }finally{
        setIsLoading(false);
      }
    };
  
    reader.readAsArrayBuffer(file);
  };
  

  const handleBack = () => {
    navigate(-1);
  };

  const handleTotalUnitRowChange = (e) => {
    const newValue = parseInt(e.target.value) || 0;
    const actualUnitCount = units.filter((unit) => unit !== null).length;

    if (newValue < actualUnitCount) {
      showErrorToast(
        `Cannot set total units below ${actualUnitCount} as there are existing units.`
      );
      setTotalUnitRow(actualUnitCount);
    } else {
      setTotalUnitRow(newValue);
    }
  };

  return (
    <div className="bg-appGrayBackground min-h-screen pb-16">
      <AdminAppBar />
      <ToastContainer />
      <div className="mt-20 pt-8 px-6 mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-center gap-6 mb-4 md:mb-0">
            <BackArrows onClick={handleBack} />
            <h1 className="text-2xl md:text-3xl font-semibold">
              {selectedPropertyDetails?.label || propertyName}
            </h1>
          </div>
          <div className="flex gap-4">
            {currentStep === 1 && (
              <button
                disabled={isLoading}
                className={`px-6 py-3 w-44 text-center ${
                  isLoading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-customGreen"
                } text-white flex items-center justify-center gap-2 rounded-[10px] transition duration-300`}
                onClick={handleNextStep}
              >
                {propertyName ? "Update Property" : "Next & Publish"}
              </button>
            )}

            {currentStep === 2 && (
              <>
                {propertyName ? (
                  <>
                    <form
                      onSubmit={handleSearchSubmit}
                      className="relative w-full md:w-[385px]"
                    >
                      <input
                        type="text"
                        placeholder="Search Unit Number"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="w-full pl-3 pr-12 h-[50px] shadow appearance-none border rounded-[10px] text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      />
                      <button
                        type="submit"
                        className="absolute right-0 w-[50px] h-[50px] top-1/2 transform -translate-y-1/2 text-white bg-customGreen p-2 rounded-r-[10px]"
                      >
                        <FiSearch size={25} className="ml-1" />
                      </button>
                    </form>

                    <StatusDropdown
                      onSelect={handleStatusFilter}
                      options={[
                        { id: "all", label: "All Statuses" },
                        ...plotStatusIds,
                      ]}
                    />
                  </>
                ) : (
                  <>
                    <button
                     disabled={isLoading}
                     className={`px-6 py-3 w-44 text-center ${
                       isLoading
                         ? "bg-gray-400 cursor-not-allowed"
                         : "bg-customGreen"
                     } text-white flex items-center justify-center gap-2 rounded-[10px] transition duration-300`}
                         onClick={() => {
                        setShowBulkModal(true);
                      }}
                    >
                      <TbFileSymlink className="text-xl" />
                      <span>Bulk Upload</span>
                    </button>
                  </>
                )}
                <button
                  disabled={isLoading}
                  className={`px-6 py-3 w-44 text-center ${
                    isLoading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-customGreen"
                  } text-white flex items-center justify-center gap-2 rounded-[10px] transition duration-300`}
                  onClick={handleSavePropertyLayoutUnit}
                >
                  <MdAddCircleOutline className="text-xl font-semibold" />
                  <span>{editMode ? "Update" : "Create"}</span>
                </button>
              </>
            )}
          </div>
        </div>

        <div className="bg-white mt-14 rounded-lg py-[30px]">
          <div
            className={`${
              propertyName ? "flex items-center justify-between px-8" : ""
            }`}
          >
            <StepProgress
              currentStep={currentStep}
              handlePrevStep={handlePrevStep}
              handleNextStep={handleNextStep}
              handleNextViewStep={handleNextViewStep}
              handlePrevViewStep={handlePrevViewStep}
              isEdit={propertyInfoStatus}
              propertyType={propertySaleType}
            />

            {/* {propertyName && currentStep === 1 && (
              <div>
                <button
                  className="px-6 py-3 w-44 text-center bg-customGreen text-white rounded-md"
                  onClick={handleNextStep}
                >
                  Update
                </button>
              </div>
            )} */}
          </div>

          {currentStep === 1 && (
            <PropertyInfoForm
              propertyInfo={propertyInfo}
              setPropertyInfo={setPropertyInfo}
              handlePropertyInfoChange={handlePropertyInfoChange}
              handleArrayFieldChange={handleArrayFieldChange}
              handleNestedPropertyInfoChange={handleNestedPropertyInfoChange}
              isEdit={editMode}
              propertyType={propertyInfo?.propertyType}
            />
          )}

          {currentStep === 2 && (
            <>
              <div className="flex items-center justify-end absolute right-6 top-[250px]  mr-6">
                <div className="flex items-center gap-3 bg-white p-2 rounded-md border-2 border-slate-200">
                  <label className="flex items-center text-sm font-medium text-gray-700 whitespace-nowrap">
                    <span className="inline-block w-1.5 h-4 bg-red-400 rounded-sm mr-2"></span>
                    Total No. of Units
                  </label>
                  <input
                    type="number"
                    name="totalUnitRow"
                    min={units.filter((unit) => unit !== null).length}
                    value={totalUnitRow === 0 ? "" : totalUnitRow}
                    onChange={handleTotalUnitRowChange}
                    placeholder="Units No"
                    //   disabled={units.length > 0}
                    disabled={editMode && units.length > 0}
                    className="w-24 px-3 py-2 border border-gray-300 rounded-md text-sm input-focus transition duration-150 ease-in-out"
                  />
                </div>
              </div>

              <LayoutUnitTable
                units={filteredUnits}
                totalUnitRow={totalUnitRow}
                onEdit={handleEditUnit}
                onAdd={handleAddUnit}
              />

              {isSliderOpen && editingUnit && (
                <LayoutUnitForm
                  isSliderOpen={isSliderOpen}
                  onHide={handleCancelUnitEdit}
                  unit={editingUnit}
                  handleChange={handleUnitFormChange}
                  handleSave={handleSaveUnit}
                  handleCancel={handleCancelUnitEdit}
                  isNew={isNewUnit}
                />
              )}
            </>
          )}
        </div>
      </div>
      <BulkUploadModel
        open={showBulkModal}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        onClose={() =>{
          setSelectedFile(null)
          setShowBulkModal(false)
        } }
        onImport={handleBulkUploadLayoutUnits}
        fileLink={"/Layout Bullk Upload.xlsx"}
        fileName="Layout Bulk Upload.xlsx"
      />

      {showValidationModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-lg p-6 max-w-2xl w-full shadow-lg">
            <h2 className="text-xl font-bold mb-4 text-red-600">
              Validation Errors
            </h2>
            <ul className="max-h-80 overflow-y-auto list-disc pl-5 text-sm text-gray-700">
              {validationErrors.map((error, idx) => (
                <li key={idx} className="mb-1">
                  {error}
                </li>
              ))}
            </ul>
            <div className="mt-4 text-right">
              <button
                className="bg-red-600 text-white px-4 py-2 rounded "
                onClick={() => {
                  setShowValidationModal(false);
                  setSelectedFile(null)
                  setValidationErrors([]);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LayoutPropertyManage;
